import {
  ROLES,
} from '../NavBar/NavigationItems/routes';

export const ALLOWED_TO_CUSTOMER_SERVICES = (role: string) =>
  [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.DEV_ADMIN,
    ROLES.KENYA_ADMIN,
    ROLES.MARKETING,
    ROLES.CUSTOMER_SERVICE,
  ].includes(role);

export const ALLOWED_TO_ADMIN = (role: string) =>
  [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.DEV_ADMIN].includes(role);

export const ALLOWED_TO_FINANCE_AND_CUSTOMER_SERVICES = (role: string) =>
  [
    ROLES.SUPER_ADMIN,
    ROLES.DEV_ADMIN,
    ROLES.ADMIN,
    ROLES.KENYA_ADMIN,
    ROLES.CUSTOMER_SERVICE,
    ROLES.FINANCE,
    ROLES.Delivery,
    ROLES.CUSTOMER_SERVICE,
  ].includes(role);

export const ALLOWED_TO_LEADS = (role: string) =>
  [
    ROLES.SUPER_ADMIN,
    ROLES.DEV_ADMIN,
    ROLES.ADMIN,
    ROLES.LEAD_ADMIN,
    ROLES.LEAD_VIEWER,
  ].includes(role);

export const ALLOWED_TO_LIVE_SCORING_ADMIN = (role: string) =>
  [
    ROLES.SUPER_ADMIN,
    ROLES.DEV_ADMIN,
    ROLES.ADMIN,
    ROLES.LIVE_SCORING_ADMIN,
  ].includes(role);

export const ALLOWED_TO_AFCON_ADMINS = (role: string) =>
  [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.AFCON_ADMIN].includes(
    role
  );
